// Shared "should a post-login gate engage here?" rule, used by the personal
// gates (profile completion, KVKK/ETK consent) and the org Terms gate.
//
//   - real mode (USE_REAL_API): any authenticated (token) non-public surface.
//   - mock mode: the seller / supply shells only (admin shell never gates in
//     the mock role-switcher).

import { useRouterState } from '@tanstack/react-router'
import { USE_REAL_API } from '../../lib/api'
import { useAuthStore } from '../../store/auth'

// Public / pre-auth routes never show a gate.
const GATE_PUBLIC_PREFIXES = [
  '/login',
  '/forgot-password',
  '/reset-password',
  '/accept',
  '/apply',
  '/onboarding',
]

export function useGateEnabled(): boolean {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const accessToken = useAuthStore((s) => s.accessToken)
  const isPublic = GATE_PUBLIC_PREFIXES.some((p) => pathname.startsWith(p))
  return USE_REAL_API
    ? Boolean(accessToken) && !isPublic
    : (pathname.startsWith('/seller') || pathname.startsWith('/supply')) && !isPublic
}
